import { config } from '~app/config';

import { makeRequest } from '@breezeventures/web-lib-ph-request/make-request';
import { ResponseSuccess } from '@breezeventures/web-lib-ph-request/types';
import { useQuery } from '@tanstack/react-query';

import type { DisbursementGetProvidersResponse } from './disbursement-providers-api';
import { providersKeys } from './providers-keys';

export const useDisbursementProviders = () => {
  return useQuery({
    queryKey: providersKeys.byAccountType('disbursement_partner_bank'),
    queryFn: async () => {
      const result = await makeRequest<
        ResponseSuccess<DisbursementGetProvidersResponse>
      >({
        url: `${config.apiHost}/paymentgate/api/v1/providers/get_providers`,
        credentials: 'include',
        payload: {
          providerGroupId: ['disbursement_partner_bank'],
          operationType: 'DISBURSEMENT_PARTNER',
          limit: 150,
        },
      });
      return result.payload?.providers ?? [];
    },
    refetchOnWindowFocus: false,
  });
};
